<template>
    <div class="stbox">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>修改密码</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>修改密码</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="confirm">提交</el-button>
            </div>
            <el-form label-position="right" :model="pwdForm" ref="hospital" :rules="pwdRules" label-width="90px"
                class="demo-ruleForm login-container">
                <el-form-item prop="oldPwd" label="原密码">
                    <el-input type="password" v-model="pwdForm.oldPwd" auto-complete="off" placeholder="请输入原密码"
                        show-password></el-input>
                </el-form-item>
                <el-form-item prop="newPwd" label="新密码">
                    <el-input type="password" v-model="pwdForm.newPwd" auto-complete="off" placeholder="请输入新密码"
                        show-password></el-input>
                </el-form-item>
                <el-form-item prop="newPwd2" label="确认密码">
                    <el-input type="password" v-model="pwdForm.newPwd2" auto-complete="off" placeholder="请再次输入新密码"
                        show-password></el-input>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>
<script type="text/ecmascript-6">
import { updatePwd } from "../../api/hospital";
export default {
    name: "welcome",
    data() {
        return {
            loginUser: {},
            hospitalNumber: '',
            pwdForm: {
                oldPwd: '',
                newPwd: '',
                newPwd2: ''
            },
            pwdRules: {
                oldPwd: [
                    { required: true, message: "请输入原密码", trigger: "blur" },
                ],
                newPwd: [
                    { required: true, message: "请输入新密码", trigger: "blur" },
                ],
                newPwd2: [
                    { required: true, message: "请再次输入新密码", trigger: "blur" },
                ],
            },
        };
    },
    mounted() {
        this.loginUser = JSON.parse(localStorage.getItem("userdata"))[0];
        this.hospitalNumber = this.loginUser.HospitalNumber;
    },
    methods: {
        confirm() {
            if (this.pwdForm.newPwd == this.pwdForm.newPwd2) {
                updatePwd({
                    oldPwd: this.pwdForm.oldPwd,
                    newPwd: this.pwdForm.newPwd,
                    hospitalNumber: this.hospitalNumber
                }).then((res) => {
                    if (res.data > 0) {
                        this.$message.success("密码修改成功，请重新登录")
                        setTimeout(() => {
                            this.$store.commit("logout", "false");
                            this.$router.push({ path: "/login" });
                            this.$message({
                                type: "success",
                                message: "已退出登录!",
                            });
                        }, 1000)
                    }
                });
            } else {
                this.$message.warning("两次输入密码不一致！请重新输入！")
            }
        },
    },
};
</script>
<style>
.stbox {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}

.text {
    font-size: 14px;
}

.item {
    margin-bottom: 5px;
    margin-top: 25px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.box-card {
    margin-top: 35px;
    width: 480px;
}
</style>


// WEBPACK FOOTER //
// src/views/charts/editPwd.vue